import { forwardRef, type HTMLAttributes } from 'react'

import { KlimbMark, type KlimbMarkProps } from './KlimbMark'
import { Row } from './Stack'
import { Wordmark } from './Wordmark'

export type LockupSize = 'sm' | 'md' | 'lg'

export interface KlimbLockupProps extends HTMLAttributes<HTMLDivElement> {
  size?: LockupSize
  markVariant?: KlimbMarkProps['variant']
  hideWordmark?: boolean
}

const SIZE_MAP: Record<LockupSize, { mark: number; word: number; gap: string }> = {
  sm: { mark: 24, word: 22, gap: 'var(--s-2)' },
  md: { mark: 32, word: 30, gap: 'var(--s-3)' },
  lg: { mark: 56, word: 52, gap: 'var(--s-4)' },
}

// KlimbLockup composes KlimbMark + Wordmark in the canonical horizontal
// arrangement. Use this anywhere the brand appears as a single unit
// (nav headers, splash screens, area shells). For mark-only or
// wordmark-only placements, use the underlying primitives directly.
export const KlimbLockup = forwardRef<HTMLDivElement, KlimbLockupProps>(function KlimbLockup(
  { size = 'md', markVariant = 'mesa', hideWordmark = false, ...rest },
  ref,
) {
  const sizing = SIZE_MAP[size]
  return (
    <Row ref={ref} gap={sizing.gap} align="center" {...rest}>
      <KlimbMark size={sizing.mark} variant={markVariant} />
      {hideWordmark ? null : <Wordmark size={sizing.word} />}
    </Row>
  )
})
